import { useQuery } from '@tanstack/react-query';
import { ImpersonationBroker, IPagedCollection, IUser } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'leadServed/manager/autocomplete';

export function useLeadServedManagerAutocompleteQuery({
	fragment,
	pageSize = 25,
	enforcePageSize = true,
	enabled,
}: {
	fragment: string;
	pageSize?: number;
	enforcePageSize?: boolean;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, fragment, pageSize, enforcePageSize],
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<IUser>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `leadServed/manager/autocomplete`,
					queryParams: {
						enforcePageSize,
						fragment,
						pageSize,
					},
				}),
				'GET'
			);
		},
		enabled,
	});
}
